import React, { Component } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";

import ExtraProductBox from "./ExtraProductBox";

import "./ExtraProducts.scss";

const settings = {
  arrows: true,
  dots: true,
  initialSlide: 0,
  slidesToShow: 4,
  slidesToScroll: 4,
  speed: 500,
  nextArrow: (
    <span>
      <i className="fa fa-chevron-right" />
    </span>
  ),
  prevArrow: (
    <span>
      <i className="fa fa-chevron-left" />
    </span>
  ),
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
};

/**
 * ExtraProducts
 */
class ExtraProducts extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    cartItem: PropTypes.any,
    cartItemIndex: PropTypes.number.isRequired,
    isProductInCart: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    extraProducts: PropTypes.any.isRequired
  };

  static contextTypes = {
    t: PropTypes.func
  };

  static defaultProps = {
    cartItem: null
  };

  // shouldComponentUpdate(nextProps) {
  //   // for some reason this does not work in the connect() "areMergedPropsEqual" option
  //   return !isEqual(this.props, nextProps);
  // }

  render() {
    const { cartItem, isProductInCart } = this.props;

    const extraProducts = this.props.extraProducts.filter(p => {
      if (!cartItem || !cartItem.extraProducts) {
        return true;
      }
      return cartItem.extraProducts.filter(v => v.id === p.get("id")).length === 0;
    });

    if (extraProducts.size === 0 || !cartItem) {
      return null;
    }

    return (
      <div className={`Cart__Step1__ExtraProducts${isProductInCart ? "" : " Cart__Step1__ExtraProducts--disabled2"}`}>
        <div className="Cart__Step1__ExtraProducts__Title">{this.context.t("Checkout bargains")}</div>
        <div className="Cart__Step1__ExtraProducts__Container col-12">
          <Slider {...settings}>
            {extraProducts.map(p => (
              <ExtraProductBox
                key={p.get("id")}
                product={p}
                cartItem={this.props.cartItem}
                cartItemIndex={this.props.cartItemIndex}
                disabled={!isProductInCart}
              />
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default ExtraProducts;
